/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Warning = styled.div({
  borderRadius: `${borderRadius()}px`,
  border: `1px solid ${token('color.border.warning')}`,
  background: token('color.background.warning'),
  padding: token('space.200'),
  display: 'flex',
  minWidth: '392px',
  maxWidth: '636px',
});

export const Header = styled.div({
  font: token('font.heading.xsmall'),
  margin: `${token('space.050')} 0 ${token('space.100')}`,
});

export const WarningIcon = styled.span({
  alignSelf: 'flex-start',
  color: token('color.icon.warning'),
  display: 'flex',
  flexShrink: 0,
  marginRight: token('space.200'),
});
